import { ArrowLeft, ArrowUpRight, Linkedin } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import SeoHead from "@/seo/SeoHead";

export default function ArticlePage({ page, pathname }) {
  const formattedDate = new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric"
  }).format(new Date(`${page.published}T00:00:00`));

  return (
    <div id="top" className="grain min-h-screen bg-ink text-ivory">
      <SeoHead page={page} pathname={pathname} />
      <Nav />
      <main>
        <article>
          <header className="border-b border-surface-2">
            <div className="mx-auto max-w-[1000px] px-6 pb-24 pt-40 md:px-16 md:pb-32 md:pt-48">
              <a
                href="/insights/"
                className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-mutedfg hover:text-brass"
              >
                <ArrowLeft size={14} /> All insights
              </a>
              <div className="mt-14 text-[11px] uppercase tracking-[0.28em] text-brass">{page.eyebrow}</div>
              <h1 className="mt-6 font-serif-display text-5xl font-light leading-[0.95] tracking-[-0.025em] text-ivory md:text-7xl lg:text-8xl">
                {page.h1}<span className="text-brass italic">.</span>
              </h1>
              <p className="mt-10 max-w-3xl text-xl font-light leading-relaxed text-mutedfg">{page.intro}</p>
              <div className="mt-10 flex flex-wrap items-center gap-4 text-[11px] uppercase tracking-[0.22em] text-mutedfg">
                <span>{formattedDate}</span>
                <span className="h-3 w-px bg-brass/50" />
                <span>{page.readTime}</span>
                <span className="h-3 w-px bg-brass/50" />
                <span>By Asad Hatimi</span>
              </div>
            </div>
          </header>

          <div className="mx-auto max-w-[1000px] px-6 py-24 md:px-16 md:py-32">
            {page.sections.map((section, index) => (
              <section key={section.heading} className="grid grid-cols-12 gap-7 border-t border-surface-2 py-12 first:border-0 first:pt-0">
                <div className="col-span-12 text-[11px] uppercase tracking-[0.28em] text-brass md:col-span-2">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <div className="col-span-12 md:col-span-10">
                  <h2 className="font-serif-display text-3xl font-light leading-tight text-ivory md:text-5xl">
                    {section.heading}
                  </h2>
                  <div className="mt-7 max-w-3xl space-y-6 text-lg font-light leading-[1.8] text-mutedfg">
                    {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                  </div>
                </div>
              </section>
            ))}

            <aside className="mt-16 border border-surface-2 p-8 md:p-12">
              <div className="text-[11px] uppercase tracking-[0.28em] text-brass">The PMC Perspective</div>
              <h2 className="mt-4 font-serif-display text-3xl font-light text-ivory">
                Practical field notes on capital-project governance.
              </h2>
              <div className="mt-8 flex flex-wrap gap-4">
                <a
                  href="https://www.linkedin.com/in/asad-hatimi-program-leader/recent-activity/articles/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 bg-brass px-7 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-ink"
                >
                  <Linkedin size={15} /> Follow on LinkedIn
                </a>
                <a
                  href="/#contact"
                  className="inline-flex items-center gap-3 border border-surface-2 px-7 py-4 text-xs uppercase tracking-[0.2em] text-ivory hover:border-brass hover:text-brass"
                >
                  Discuss an advisory mandate <ArrowUpRight size={15} />
                </a>
              </div>
            </aside>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
